const userCookieName = /last-known-sol-user-id/i;
const cookieNameValue = 'last-known-sol-user-id';

export const userCookieExists = () => userCookieName.test(document.cookie);

export const removeUserCookie = () => {
  document.cookie = `${cookieNameValue}=; expires=${new Date().toUTCString()};`;
};
